import React,{useEffect} from 'react'
import GlossaryContainer from './glossary_container';



const GlossaryPage = () => {

  useEffect(() => {
    document.title = "Glossary";
    var link = !document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', document.location.protocol + '//' + document.location.host + document.location.pathname);
    document.head.appendChild(link);
  }, []);

    return (
      <GlossaryContainer></GlossaryContainer>
      
    )
}

export default GlossaryPage

